import React from 'react'
import headerimg from '../assets/OWRB header.png'
import Onebtn from '../assets/1.png'
import Videobtn from '../assets/Button - Video.png'
import Cimarronbtn from '../assets/Button - Cimarron.png'
import AddiResource from '../components/AddiResource';
import Cimarronpdf from '../assets/pdf/LowerCimarron.pdf'

export default function LowerCimarron() {
    return (
        <div>
            <main className="flex-shrink-0 modular min-vh-100 mt-5">


                <img className='my-5' style={{ maxWidth: "100%" }} src={headerimg} />

                <div className="container mt-2">

                    <div className='row'>
                        <div className='col-1 d-none d-lg-block'></div>
                        <div className='col-12 col-lg-10'>

                            <div className="row col-12">

                                <div className="col-md-4 col-lg-2">
                                    <div className="row" style={{ paddingBottom: "10px" }}>
                                        <a href={Cimarronpdf} without rel="noopener noreferrer" target="_blank"><img
                                            src={Onebtn} style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                    <div className="row text-center" style={{ paddingBottom: "10px" }}>
                                        <a href="https://vimeo.com/503096608/c2e637fbe7" target="_blank"><img
                                            src={Videobtn} height="150" width="150"
                                            style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                    <div className="row">
                                        <a href="https://lowercimarron.metroquest.com/" target="_blank"><img
                                            src={Cimarronbtn} style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                </div>
                                <div className="col-md-8 col-lg-10">
                                    <div className="container" style={{ minHeight: "400px" }}>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <h1>Lower Cimarron</h1>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>The Lower Cimarron watershed is approximately 1,400 square miles and is
                                                    in the north central portion of Oklahoma. It is generally located east
                                                    of I-35, south of U.S. Route 412, west of SH-51, and north of I-44. The
                                                    Lower Cimarron River generally drains from west to east until it reaches
                                                    the confluence of Lake Keystone near the city of Mannford.</p>
                                                <p>The watershed contains 37 communities, 12 of which participate in the
                                                    National Flood Insurance Program (NFIP), and includes the counties of
                                                    Creek, Garfield, Lincoln, Logan, Noble, Pawnee, Payne, and Tulsa.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>On the left side of this screen, you will find two round blue buttons
                                                    that you can click on. The top button links to a Tutorial Video which
                                                    explains how to take the online interactive survey about your watershed.
                                                    The lower button will take you to the actual survey.</p>
                                                <p>At the bottom of the screen, you will find a slew of additional free
                                                    resources that cover topics such as Risk Mapping, National Flood
                                                    Insurance Program, Dam Safety, Hazard Mitigation Assistance Grants, a
                                                    link to Oklahoma Water Resource Board, and much more.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='col-1 d-none d-lg-block'></div>
                    </div>

                </div>

            </main>
            <AddiResource />
        </div>

    )
}
